// services/organizationService.js
import api from './api';

const organizationService = {
  /**
   * Get current user's organization
   */
  async getOrganization() {
    return await api.get('/organization');
  },

  /**
   * Create a new organization
   */
  async createOrganization(data) {
    return await api.post('/organization', data);
  },

  /**
   * Update organization details
   */
  async updateOrganization(data) {
    return await api.put('/organization', data);
  },

  /**
   * Get all users in the organization
   */
  async getOrganizationUsers() {
    return await api.get('/organization/users');
  },

  /**
   * Send invitation to join the organization
   */
  async sendInvitation(email, organizationRole = 'member') {
    return await api.post('/organization/invitations', { email, organizationRole });
  },

  /**
   * Get all invitations for the organization
   */
  async getInvitations() {
    return await api.get('/organization/invitations');
  },

  /**
   * Cancel an invitation
   */
  async cancelInvitation(invitationId) {
    return await api.delete(`/organization/invitations/${invitationId}`);
  },

  /**
   * Update a user's organization role
   */
  async updateUserRole(userId, organizationRole) {
    return await api.put(`/organization/users/${userId}/role`, { organizationRole });
  },

  /**
   * Remove a user from the organization
   */
  async removeUser(userId) {
    return await api.delete(`/organization/users/${userId}`);
  },

  /**
   * Get email settings for the organization
   */
  async getEmailSettings() {
    return await api.get('/organization/email-settings');
  },

  /**
   * Update email settings for the organization
   */
  async updateEmailSettings(settings) {
    return await api.put('/organization/email-settings', settings);
  }
};

export default organizationService;
